// Server-side retention for the Driver Routes tabs — stores a user's loaded
// week in Netlify Blobs (via /.netlify/functions/user-store), so it survives
// browser clears and follows the user across devices. Compressed with
// lz-string (~3 MB week -> ~300 KB) before it leaves the browser.
import LZString from 'lz-string';

const URL = '/.netlify/functions/user-store';

export async function cloudSave(login, key, obj) {
  if (!login) return false;
  const data = obj == null ? '' : LZString.compressToBase64(JSON.stringify(obj));
  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ op: 'set', login, key, data }),
    });
    return res.ok;
  } catch (e) { return false; }
}

export async function cloudLoad(login, key) {
  if (!login) return null;
  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ op: 'get', login, key }),
    });
    if (!res.ok) return null;
    const j = await res.json();
    if (!j || !j.data) return null;
    return JSON.parse(LZString.decompressFromBase64(j.data));
  } catch (e) { return null; }
}
